import React, { useState } from 'react'
import { Card, Button, Radio, Progress, Result } from 'antd'
import { CheckCircleOutlined, ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import './ConstitutionIdentification.css'

const ConstitutionIdentification: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const [answers, setAnswers] = useState<Record<number, string>>({})
  const [completed, setCompleted] = useState(false)

  const questions = [
    {
      id: 1,
      question: '您容易感到疲劳吗？',
      options: [
        { value: 'a', label: '经常' },
        { value: 'b', label: '偶尔' },
        { value: 'c', label: '很少' },
      ],
    },
    // 更多问题...
  ]

  const handleAnswer = (value: string) => {
    setAnswers({ ...answers, [currentStep]: value })
  }

  const handleNext = () => {
    if (currentStep < questions.length - 1) {
      setCurrentStep(currentStep + 1)
    } else {
      setCompleted(true)
    }
  }

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
    }
  }

  if (completed) {
    return (
      <div className="constitution-result-page">
        <Result
          icon={<CheckCircleOutlined style={{ color: '#2E7D32' }} />}
          title="体质识别完成"
          subTitle="您的体质类型：平和质"
          extra={[
            <Button type="primary" key="report">
              查看详细报告
            </Button>,
            <Button key="retry" onClick={() => {
              setCompleted(false)
              setCurrentStep(0)
              setAnswers({})
            }}>
              重新测试
            </Button>,
          ]}
        />
      </div>
    )
  }

  const currentQuestion = questions[currentStep]
  const progress = ((currentStep + 1) / questions.length) * 100

  return (
    <div className="constitution-identification-page">
      <div className="question-container">
        <Card className="question-card">
          <div className="progress-bar">
            <Progress percent={progress} showInfo={false} />
            <span className="progress-text">
              第 {currentStep + 1} 题 / 共 {questions.length} 题
            </span>
          </div>

          <div className="question-content">
            <h2 className="question-title">{currentQuestion.question}</h2>
            <Radio.Group
              value={answers[currentStep]}
              onChange={(e) => handleAnswer(e.target.value)}
              className="question-options"
            >
              {currentQuestion.options.map((option) => (
                <Radio.Button
                  key={option.value}
                  value={option.value}
                  className="option-button"
                >
                  {option.label}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>

          <div className="question-actions">
            <Button
              icon={<ArrowLeftOutlined />}
              disabled={currentStep === 0}
              onClick={handlePrev}
            >
              上一题
            </Button>
            <Button
              type="primary"
              icon={<ArrowRightOutlined />}
              disabled={!answers[currentStep]}
              onClick={handleNext}
            >
              {currentStep === questions.length - 1 ? '完成' : '下一题'}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default ConstitutionIdentification

